import axios from '@utils/axios';

const resultsDetail = {
  state: {
    customerId: 0,
    genotypes: []
  },
  mutations: {
    setCustomerId(state, id) {
      state.customerId = id;
    },
    setGenotypes(state, genotypes) {
      state.genotypes = genotypes;
    }
  },
  actions: {
    fetchResult(context) {
      return axios.get('admin/results/getcustomerresult', {
        params: {
          CustomerId: context.state.customerId
        }
      })
        .then((res) => {
          if (res.status === 200) {
            context.commit('setGenotypes', res.data.result);
            Promise.resolve(true);
          }
        });
    },
    resetContext(context) {
      context.commit('setCustomerId', 0);
      context.commit('setGenotypes', []);
    }
  },
  namespaced: true
};

export default resultsDetail;
